var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Action, Selector, State, Store } from '@ngxs/store';
import { ShareableLinksApiService } from './shareable-links-api.service';
import { finalize, tap } from 'rxjs/operators';
import { DriveState } from '../../state/drive-state';
import { Settings } from 'common/core/config/settings.service';
import { SecurityHandler } from 'app/drive/security/security-handler';
var LoadShareableLink = /** @class */ (function () {
    function LoadShareableLink(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
    }
    LoadShareableLink.type = '[Shareable Link] Load From Backend';
    return LoadShareableLink;
}());
export { LoadShareableLink };
var UpdateShareableLink = /** @class */ (function () {
    function UpdateShareableLink(options) {
        this.options = options;
    }
    UpdateShareableLink.type = '[Shareable Link] Update';
    return UpdateShareableLink;
}());
export { UpdateShareableLink };
var CreateShareableLink = /** @class */ (function () {
    function CreateShareableLink(options) {
        this.options = options;
    }
    CreateShareableLink.type = '[Shareable Link] Create';
    return CreateShareableLink;
}());
export { CreateShareableLink };
var DeleteShareableLink = /** @class */ (function () {
    function DeleteShareableLink() {
    }
    DeleteShareableLink.type = '[Shareable Link] Delete';
    return DeleteShareableLink;
}());
export { DeleteShareableLink };
var ToggleOptionsPanel = /** @class */ (function () {
    function ToggleOptionsPanel() {
    }
    ToggleOptionsPanel.type = '[Shareable Link] Toggle Options Panel Visibility';
    return ToggleOptionsPanel;
}());
export { ToggleOptionsPanel };
var LinkCopySuccess = /** @class */ (function () {
    function LinkCopySuccess() {
    }
    LinkCopySuccess.type = '[Shareable Link] Copy To Clipboard Success';
    return LinkCopySuccess;
}());
export { LinkCopySuccess };
var ResetShareLinkState = /** @class */ (function () {
    function ResetShareLinkState() {
    }
    ResetShareLinkState.type = '[Shareable Link] Reset State';
    return ResetShareLinkState;
}());
export { ResetShareLinkState };
var defaultState = {
    link: null,
    loading: false,
    optionsPanelVisible: true,
    backendErrors: {},
    cache: {},
    linkOptions: {
        allowDownload: false,
        allowEdit: false,
        expiresAt: null,
        password: null,
    }
};
var ShareLinkState = /** @class */ (function () {
    function ShareLinkState(store, settings, linksApi) {
        this.store = store;
        this.settings = settings;
        this.linksApi = linksApi;
    }
    ShareLinkState.loading = function (state) {
        return state.loading;
    };
    ShareLinkState.link = function (state) {
        return state.link;
    };
    ShareLinkState.optionsVisible = function (state) {
        return !state.loading && state.optionsPanelVisible;
    };
    ShareLinkState.backendErrors = function (state) {
        return state.backendErrors;
    };
    ShareLinkState.prototype.createShareableLink = function (ctx, action) {
        var _this = this;
        var entryId = this.store.selectSnapshot(DriveState.selectedEntryIds)[0];
        ctx.patchState({ loading: true });
        return this.linksApi.create(entryId, action.options)
            .pipe(finalize(function () { return ctx.patchState({ loading: false, backendErrors: {} }); }), tap(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = response;
                        return [4 /*yield*/, this.getLinkWithDecryptionKey(response.link)];
                    case 1:
                        _a.link = _c.sent();
                        ctx.patchState({
                            cache: __assign({}, ctx.getState().cache, (_b = {}, _b[response.link.entry_id] = response.link, _b)),
                            link: response.link,
                            optionsPanelVisible: false
                        });
                        return [2 /*return*/];
                }
            });
        }); }, function (errorResponse) {
            ctx.patchState({ backendErrors: errorResponse.messages });
        }));
    };
    ShareLinkState.prototype.getLinkWithDecryptionKey = function (link) {
        return __awaiter(this, void 0, void 0, function () {
            var entry, keyDec;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entry = link.entry;
                        return [4 /*yield*/, new SecurityHandler().decryptKeyString(entry.key)
                            // Update link hash
                        ];
                    case 1:
                        keyDec = _a.sent();
                        // Update link hash
                        link.hash = link.hash + '!' + keyDec;
                        return [2 /*return*/, link];
                }
            });
        });
    };
    ShareLinkState.prototype.updateLink = function (ctx, action) {
        var _this = this;
        var link = ctx.getState().link;
        ctx.patchState({ loading: true });
        return this.linksApi.update(link.id, action.options)
            .pipe(finalize(function () { return ctx.patchState({ loading: false, backendErrors: {} }); }), tap(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = response;
                        return [4 /*yield*/, this.getLinkWithDecryptionKey(response.link)];
                    case 1:
                        _a.link = _c.sent();
                        ctx.patchState({
                            link: response.link,
                            cache: __assign({}, ctx.getState().cache, (_b = {}, _b[link.entry_id] = response.link, _b)),
                            optionsPanelVisible: false
                        });
                        return [2 /*return*/];
                }
            });
        }); }, function (errorResponse) {
            ctx.patchState({ backendErrors: errorResponse.messages });
        }));
    };
    ShareLinkState.prototype.loadShareableLink = function (ctx, action) {
        var _this = this;
        var entryId = this.store.selectSnapshot(DriveState.selectedEntryIds)[0], cachedLink = ctx.getState().cache[entryId];
        if (cachedLink) {
            return ctx.patchState({ link: cachedLink, optionsPanelVisible: false });
        }
        ctx.patchState({ loading: true });
        return this.linksApi.findByEntryId(entryId, { autoCreate: action.options.autoCreate })
            .pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = response;
                        return [4 /*yield*/, this.getLinkWithDecryptionKey(response.link)];
                    case 1:
                        _a.link = _c.sent();
                        ctx.patchState({
                            link: response.link,
                            optionsPanelVisible: false,
                            cache: __assign({}, ctx.getState().cache, (_b = {}, _b[response.link.entry_id] = response.link, _b)),
                        });
                        return [2 /*return*/];
                }
            });
        }); }, function () { }));
    };
    ShareLinkState.prototype.deleteShareableLink = function (ctx) {
        var link = ctx.getState().link;
        ctx.patchState({ loading: true });
        return this.linksApi.delete(link.id)
            .pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function () {
            var cache = ctx.getState().cache;
            var cacheRemoved = Object.keys(cache)
                .filter(function (key) { return key != link.entry_id.toString(); })
                .reduce(function (obj, key) {
                obj[key] = cache[key];
                return obj;
            }, {});
            ctx.patchState({
                link: null,
                cache: cacheRemoved
            });
        }));
    };
    ShareLinkState.prototype.toggleOptionsPanel = function (ctx) {
        ctx.patchState({
            optionsPanelVisible: !ctx.getState().optionsPanelVisible
        });
    };
    ShareLinkState.prototype.resetShareLinkState = function (ctx) {
        return ctx.patchState(__assign({}, ctx.getState(), defaultState));
    };
    __decorate([
        Action(CreateShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "createShareableLink", null);
    __decorate([
        Action(UpdateShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "updateLink", null);
    __decorate([
        Action(LoadShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadShareableLink]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "loadShareableLink", null);
    __decorate([
        Action(DeleteShareableLink),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "deleteShareableLink", null);
    __decorate([
        Action(ToggleOptionsPanel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "toggleOptionsPanel", null);
    __decorate([
        Action(ResetShareLinkState, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState.prototype, "resetShareLinkState", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "loading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "link", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "optionsVisible", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareLinkState, "backendErrors", null);
    ShareLinkState = __decorate([
        State({
            name: 'shareLink',
            defaults: defaultState
        }),
        __metadata("design:paramtypes", [Store,
            Settings,
            ShareableLinksApiService])
    ], ShareLinkState);
    return ShareLinkState;
}());
export { ShareLinkState };
